import { render, staticRenderFns } from "./TreatmentEmptySection.vue?vue&type=template&id=7db28c0e"
import script from "./TreatmentEmptySection.vue?vue&type=script&lang=js"
export * from "./TreatmentEmptySection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentEmptySection.vue?vue&type=style&index=0&id=7db28c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports